/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 10.07.2014, 19:11
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { LiveEnvironment } from "./LiveEnvironment";

/**
 * Represents the live or production environment of the client
 */
export class PreClientEnvironment extends LiveEnvironment {
    public static PRE_CLIENT_ENVIRONMENT_ID: string = "PreClientEnvironment";

    constructor() {
        super(PreClientEnvironment.PRE_CLIENT_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        if (!this._data.globals.urlVariables.forceToShowTestServers) {
            this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-netconf/{gameId}/{networkId}.xml";
        }

        this._languageConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config-preClient/language/{gameId}/{languageVersion}/{languageCode}.{zipSuffix}";
        this._cldrConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config-preClient/language/{gameId}/cldr";

        this._versionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config-preClient/version/{gameId}/version.json";

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/branches-preClient/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/branches-preClient/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";
    }

    public isSupported(): boolean {
        return this._data.globals.isPreClient;
    }
}
